import isDisplayInsurancePopup from '@/state/isDisplayInsurancePopup'

const handleOpenInsurancePopup = (): void => {
    isDisplayInsurancePopup.value = true
}

export default handleOpenInsurancePopup
